// Lista única de grupos musculares, usada tanto na Biblioteca de Exercícios
// (tag de cada exercício) quanto no cadastro de treino (grupo do treino e de
// cada exercício), para que a tag escolhida na biblioteca sempre bata com uma
// opção do formulário de treino.
// Nomes alinhados com os grupos já cadastrados de verdade em exercicios_biblioteca
// (não renomear sem migrar os registros existentes).
export const GRUPOS_MUSCULARES = [
  'Quadríceps', 'Posteriores', 'Glúteos', 'Pernas completo',
  'Ombros', 'Peito', 'Bíceps', 'Tríceps', 'Costas', 'Lombares', 'Panturrilha',
  'Core', 'Cardio', 'Mobilidade', 'Outro',
];
